export default "__VITE_ASSET__D$2BGK$K__"